<!-- @format -->

@for (attachments of externalAttainedStudyAttachments; track attachments) {
  @for (document of attachments?.documents; track document) {
    @for (lang of getAttachmentLanguages(document); track lang) {
      <div class="sis-mt-sm">
        @if (document.attachments[lang]; as attachment) {
          @if (showLink) {
            <a
              fudisLink
              [title]="
                (document.title | localizedString: lang) +
                ' (' +
                readableFileSizeString(attachment.size) +
                ')' +
                ' (EMREX:' +
                document.externalIdentifier +
                ')'
              "
              [href]="attachment.preSignedGetUrl"
              [external]="true"
              data-cy="attachment"></a>
          }
          @if (!showLink) {
            <div class="object file-preview">
              <span class="file-name"
                >{{ document.title | localizedString: lang }} ({{ readableFileSizeString(attachment.size) }}) (EMREX:
                {{ document.externalIdentifier }})</span
              >
            </div>
          }
          <p>{{ getDescriptionForLang(document, lang) }}</p>
        }
      </div>
    }
  }
}
